import { defineMessages } from 'react-intl';

export const i18n: {
	verified: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	verified: {
		id: 'dynamic-cards-search-page.filters.names.verified',
		defaultMessage: 'Verified',
		description: 'Label for filtering for Verified content',
	},
});
